module.exports = __webpack_public_path__ + "static/media/check-you-order.da0857fc.svg";